import React from "react";
import { isImage, isVideo } from "../../../shared/utils/function";
import { useMediaPreview } from "../../../shared/hooks/useMediaPreview";
import VideoPreviewThumbnail from "./VideoPreviewThumbnail";

const FilePreviewMedia = ({
  fileObj,
  variant = "grid",
  imageClassName = "file-preview-image",
  videoClassName = "file-preview-video",
  placeholderIconClassName = "file-placeholder-icon",
  showPlaceholderName = true,
}) => {
  const { displayUrl, loading } = useMediaPreview(
    fileObj.file,
    fileObj.previewUrl
  );

  if (loading) {
    return (
      <div className="file-preview-loading">
        <i className={`fa fa-spinner fa-spin ${placeholderIconClassName}`} />
      </div>
    );
  }

  if (displayUrl && isImage(fileObj.file)) {
    return (
      <img
        src={displayUrl}
        alt={fileObj.file.name}
        className={imageClassName}
      />
    );
  }

  if (displayUrl && isVideo(fileObj.file)) {
    return (
      <VideoPreviewThumbnail
        src={displayUrl}
        poster={fileObj.posterUrl}
        variant={variant}
        videoClassName={videoClassName}
      />
    );
  }

  return (
    <div className="file-placeholder">
      <i className={`fa ${isVideo(fileObj.file) ? "fa-video" : "fa-file"} ${placeholderIconClassName}`} />
      {showPlaceholderName && (
        <span className="file-placeholder-name">{fileObj.file.name}</span>
      )}
    </div>
  );
};

export default FilePreviewMedia;
